var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.243 12H.757M11.257 23L22.9 12.751a1 1 0 000-1.5L11.257 1",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjMuMjQzMSAxMkgwLjc1NzA4IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuMjU3MSAyM0wyMi45MDAxIDEyLjc1MUMyMy4xMTUzIDEyLjU2MTIgMjMuMjM4NiAxMi4yODggMjMuMjM4NiAxMi4wMDFDMjMuMjM4NiAxMS43MTQgMjMuMTE1MyAxMS40NDA4IDIyLjkwMDEgMTEuMjUxTDExLjI1NzEgMSIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgRightArrow as ReactComponent };